import React, {useEffect} from 'react'
import './services.css'
import { sketchServiceData } from "../../Data"
import Aos from "aos"
import 'aos/dist/aos.css'
import {Helmet} from "react-helmet-async";

const List = ({ title, items }) => (
    <article className="service">
        <div className="service_head">
            <h2>{title}</h2>
        </div>
        <ul className="service_list">
            {items.map((service, idx) => (
                <li key={idx} className="service_list_item">
                    <div className="service_row">
                        <span className="service_name">{service.name}</span>
                        <span className="price">{service.price}</span>
                    </div>
                </li>
            ))}
        </ul>
    </article>
);

const Services = ({observer, sectionRef}) => {
    useEffect(() => {
        Aos.init({duration:1500})
    }, [])

    useEffect(() => {
        if (observer) {
            observer.observe(sectionRef.current)
        }
    }, [sectionRef, observer])

    return (
        <section id='services' ref={sectionRef}>
            <Helmet>
                <script type="application/ld+json">{JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "Service",
                    "name": "Architectural sketches & 2D or 3D plans",
                    "provider": { "@type": "Person", "name": "Yana" },
                    "areaServed": "Worldwide",
                    "offers": [
                        ...sketchServiceData.map(s => ({ "@type": "Offer", "name": s.name, "price": s.price }))
                    ]
                })}
                </script>
            </Helmet>
            <div data-aos='fade-up' data-aos-duration='2000' className='services_header'>
                <h2 className="eyebrow">What I Offer</h2>
                <h1>Price list</h1>
                <p className="services_sub">
                    Transparent starting prices. Final cost depends on scope, detail level, and deadlines.
                </p>
            </div>
            <div data-aos='zoom-in' data-aos-duration='2000' className='container services_container'>
                <List title="Sketching" items={sketchServiceData}/>
            </div>
        </section>
    );
};

export default Services;
